import React from 'react';
import { Button } from 'react-bootstrap';
import { FaArrowRight } from "react-icons/fa";
import './CustomButton.css';

const CustomButton = ({ text, onClick, variant = 'navy', size = 'md', className = '', showArrow = false }) => {
  return (
    <Button 
      className={`custom-pill-btn btn-${variant} btn-sz-${size} ${className} d-flex align-items-center justify-content-center ${showArrow ? 'gap-3' : ''}`}
      onClick={onClick}
      style={{ paddingRight: showArrow ? '8px' : '24px', paddingLeft: '24px' }}
    >
      <span className="btn-text">{text}</span>
      {showArrow && (
        <span className="arrow-circle">
          <FaArrowRight />
        </span>
      )}
    </Button>
  );
};

export default CustomButton;